import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-658c8580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert_wrapper" }
const _hoisted_2 = { class: "alert_body" }
const _hoisted_3 = { class: "alert_title" }
const _hoisted_4 = { class: "alert_text" }
const _hoisted_5 = { class: "my-3" }
const _hoisted_6 = { class: "alert_p" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert_p" }, "↓", -1))
const _hoisted_8 = { class: "alert_p" }
const _hoisted_9 = { class: "alert_buttons_wrapper" }

export function render(_ctx, _cache) {
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('timetable.copying_alert.copying_trainings')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('timetable.copying_alert.alert_text')), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.alertCopyingWeek), 1),
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.alertPastedWeek), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('success')))
        }, _toDisplayString(_ctx.$t('timetable.copying_alert.copy')), 1),
        _createElementVNode("button", {
          class: "secondary_button button_space",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('cancel')))
        }, _toDisplayString(_ctx.$t('timetable.copying_alert.cancel')), 1)
      ])
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}